import { FC, useEffect, useState } from "react";
import Link from "next/link";
import { MenuLarge, MenuMobile } from "../ui/menu";
import { MoreIcon } from "./svg/MoreIcon";
import * as Styled from "./navbar.styles";

interface NavBarProps {
  navbarTheme?: string;
}

export const NavBar: FC<NavBarProps> = ({ navbarTheme }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenMenu = () => {
    setIsOpen(!isOpen);
  };

  const [scrollData, setScrollData] = useState({
    scrollY: 0,
    lastY: 0,
  });

  const [showNavbar, setShowNavbar] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      setScrollData({
        scrollY: window.scrollY,
        lastY: scrollData.scrollY,
      });
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [scrollData.scrollY]);

  useEffect(() => {
    if (scrollData.scrollY === 0) {
      setShowNavbar(true);
    } else if (scrollData.scrollY > scrollData.lastY) {
      setShowNavbar(false);
    } else {
      setShowNavbar(true);
    }
  }, [scrollData.scrollY, scrollData.lastY]);

  return (
    <Styled.NavbarContainer theme={navbarTheme} shownavbar={showNavbar} className="animate__animated animate__fadeIn">
      <Styled.NavbarBox>
        <div id="vision">
          <Link href="/">
            <Styled.LogoIcon>
              <Styled.ImgLogo src={`/assets/navbar/cellectLogo${navbarTheme}.svg`} alt="cellect-Log-img" />
            </Styled.LogoIcon>
          </Link>
        </div>
        <Styled.MenuLargeContainer>
          <MenuLarge theme={navbarTheme} />
        </Styled.MenuLargeContainer>
        <Styled.MenuIconSmall onClick={handleOpenMenu}>
          <MoreIcon theme={navbarTheme} />
          <MenuMobile isOpen={isOpen} handleOpenMenu={handleOpenMenu} theme={navbarTheme} />
        </Styled.MenuIconSmall>
      </Styled.NavbarBox>
    </Styled.NavbarContainer>
  );
};
